// extracted by mini-css-extract-plugin
export default {"messageButton":"style_messageButton__oxkLU","buttonRestricteToMessage":"style_buttonRestricteToMessage__2S5FA"};